import React, { createContext, useContext, useState, ReactNode } from 'react';

interface JoyrideContextType {
    isJoyrideAvailable: boolean;
    setIsJoyrideAvailable: (available: boolean) => void;
    restartTour: (() => void) | null;
    setRestartTour: (callback: (() => void) | null) => void;
}

const JoyrideContext = createContext<JoyrideContextType | undefined>(undefined);

export const JoyrideProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isJoyrideAvailable, setIsJoyrideAvailable] = useState(false);
    const [restartTour, setRestartTour] = useState<(() => void) | null>(null);

    return (
        <JoyrideContext.Provider
            value={{
                isJoyrideAvailable,
                setIsJoyrideAvailable,
                restartTour,
                setRestartTour,
            }}
        >
            {children}
        </JoyrideContext.Provider>
    );
};

export const useJoyrideContext = () => {
    const context = useContext(JoyrideContext);
    if (!context) {
        throw new Error('useJoyrideContext must be used within a JoyrideProvider');
    }
    return context;
};
